@use '@design/bapf-pattern-library/source/sass/vendor/bootstrap';
@use '@design/bapf-pattern-library/source/sass/globals' as *;
@use '@design/bapf-pattern-library/source/sass/patterns/header';
@use '@design/bapf-pattern-library/source/sass/patterns/dropdown';
@use '@design/bapf-pattern-library/source/sass/patterns/tabbar';
@use '@design/bapf-pattern-library/source/sass/patterns/button';
@use '@design/bapf-pattern-library/source/sass/patterns/link';
@use '@design/bapf-pattern-library/source/sass/patterns/collapsible';


.initializing {
  display: none;
}

.ba-keyboard-mode {
  :focus,
  .ba-focused { // für händisch gesetzte Focusrahmen
    @include dt-focus-frame();
  }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
  .ba-header-international {
    .ba-nav-main {
      height: 72px;
    }

    .ba-header-megaflyout-container {
      display: none;
    }
  }

}
